import api from './api';

const produtoService = {
  // Listar produtos com paginação e filtros
  async list(params = {}) {
    try {
      const response = await api.get('/produtos', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar produtos:', error);
      throw error;
    }
  },

  // Buscar produto por ID
  async getById(id, extensaoId = null) {
    try {
      const params = extensaoId ? { extensao: extensaoId } : {};
      const response = await api.get(`/produtos/${id}`, { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar produto:', error);
      throw error;
    }
  },

  // Criar novo produto
  async create(data) {
    try {
      const response = await api.post('/produtos', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar produto:', error);
      throw error;
    }
  },

  // Atualizar produto
  async update(id, data) {
    try {
      const response = await api.put(`/produtos/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar produto:', error);
      throw error;
    }
  },

  // Excluir produto
  async delete(id) {
    try {
      const response = await api.delete(`/produtos/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao excluir produto:', error);
      throw error;
    }
  },

  // Buscar produtos por tipo
  async getByTipo(tipoId, extensaoId = null) {
    try {
      const params = { tipoProduto: tipoId, limit: 1000 };
      if (extensaoId) {
        params.extensao = extensaoId;
      }
      const response = await api.get(`/produtos`, { params });
      
      // Debug log para verificar a estrutura da resposta
      console.log('Resposta bruta da API produtos:', response);
      console.log('response.data:', response.data);
      
      // A API retorna: { success: true, data: { produtos: [...], pagination: {...} } }
      if (response.data && response.data.success && response.data.data) {
        const produtos = response.data.data.produtos || response.data.data || [];
        console.log('Produtos extraídos:', produtos);
        return {
          success: true,
          data: produtos
        };
      }
      
      // Se a resposta não tem success, assumir que data é o array direto
      return {
        success: true,
        data: response.data || []
      };
    } catch (error) {
      console.error('Erro ao buscar produtos por tipo:', error);
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  },

  // Buscar tipos de produto para dropdown
  async getTipos() {
    try {
      const response = await api.get('/produtos/tipos');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar tipos de produto:', error);
      throw error;
    }
  },

  // Buscar contas para dropdown
  async getContas() {
    try {
      const response = await api.get('/produtos/contas');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar contas:', error);
      throw error;
    }
  }
};

export default produtoService;
